import React from 'react';
export function TruthSection() {
  return <section className="w-full bg-[#1a1f2e] py-16 md:py-24 px-4" data-id="element-213">
      <div className="max-w-4xl mx-auto" data-id="element-214">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8edf4] mb-8 text-center" data-id="element-215">
          La verdad que nadie te dice
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-[#d1d9e6] leading-relaxed" data-id="element-216">
          <p data-id="element-217">Tu problema no es que "piensas mucho".</p>

          <p className="text-xl md:text-2xl font-medium text-[#e8edf4]" data-id="element-218">
            Tu problema es que tu cuerpo está en modo alerta y tu mente está
            intentando salvarte con lo único que sabe: pensar y resolver.
          </p>

          <p data-id="element-219">Por eso cuando te dicen "relájate" tu cuerpo no entiende.</p>
        </div>
      </div>
    </section>;
}